import { useAuth } from "@clerk/react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";
import { useOnboardingStatus } from "@/lib/use-onboarding-status";

export function SignupRecoveryNotice() {
  const { t } = useTranslation();
  const { isSignedIn } = useAuth();
  const status = useOnboardingStatus();
  if (!isSignedIn || !status.data?.provisioned || !status.data.missingDocTypes.length) return null;
  return <div role="status" data-testid="signup-recovery-notice" className="relative z-20 shrink-0 bg-background border-b p-3 text-center text-sm">
    {t("signupRecovery")}{" "}
    <Link href="/onboarding" className="text-primary underline">{t("common.next")}</Link>
  </div>;
}